module.exports = __webpack_public_path__ + "img/solution_1.2a9d9c91.png";